namespace TabAurous.Finance {
    export interface ContraForm {
        TransId: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        TransDate: Serenity.DateEditor;
        VoucherNo: Serenity.StringEditor;
        LedgerId: Serenity.LookupEditor;
        LedgerName: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        RefDate: Serenity.DateEditor;
        EnteredBy: Serenity.LookupEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchangeRate: Serenity.DecimalEditor;
        Details: ContraDetailEditor;
        UserId: Serenity.DecimalEditor;
        TotalAmount: Serenity.DecimalEditor;
        Narration: Serenity.StringEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
    }

    export class ContraForm extends Serenity.PrefixedContext {
        static formKey = 'Finance.Contra';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ContraForm.init)  {
                ContraForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DateEditor;
                var w3 = s.LookupEditor;
                var w4 = s.DecimalEditor;
                var w5 = ContraDetailEditor;

                Q.initFormType(ContraForm, [
                    'TransId', w0,
                    'VoucherTypeId', w1,
                    'TransDate', w2,
                    'VoucherNo', w0,
                    'LedgerId', w3,
                    'LedgerName', w0,
                    'RefNo', w0,
                    'RefDate', w2,
                    'EnteredBy', w3,
                    'CurrencyId', w3,
                    'ExchangeRate', w4,
                    'Details', w5,
                    'UserId', w4,
                    'TotalAmount', w4,
                    'Narration', w0,
                    'CompanyId', w1,
                    'FinancialYearId', w1
                ]);
            }
        }
    }
}
